import React from "react";
import "./share.scss";
// import InnerShadowButton from "../../common/buttons/innerShadow";

function Share() {
  return (
    <div className=" d-flex share-containerrr">
      <img
        src={require("../../../assets/images/landing/share-image.png")}
        alt=""
      />
      <div lg="6" className="m-0 p-0 right-col text-left">
        <h2 className="title opacity-90">
          Share Toffee with Family and Friends
        </h2>
        <h3 className="sub-title">
          Insurance is important for everyone. If you’ve enjoyed the Toffee
          experience, share a word with friends and family about Toffee.
        </h3>
        <div className="btn-container">
          <a href="http://facebook.com/toffeeinsurance" target="_blank">
            <img
              src={require("../../../assets/images/icons/social/facebook.png")}
            />
          </a>
          <a href="https://www.linkedin.com/company/13396651" target="_blank">
            <img
              src={require("../../../assets/images/icons/social/linkedin.png")}
            />
          </a>
          <a
            href="https://api.whatsapp.com"
            // href="whatsapp://send?text=Hello World!&phone=+9198********1"
            target="_blank"
          >
            <img
              src={require("../../../assets/images/icons/social/whatsapp.png")}
            />
          </a>
          <a href="https://twitter.com/toffeeinsurance" target="_blank">
            <img
              src={require("../../../assets/images/icons/social/twitter.png")}
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Share;
